export const BASE_PATH = '/'

export const PATHS = {
	HOME_PAGE: `${BASE_PATH}`,
	SHOP_PAGE: `${BASE_PATH}shop`,
	PRIZE_PAGE: `${BASE_PATH}prize`,
	RANK_PAGE: `${BASE_PATH}rank`,
	SCORE_RANK_PAGE: `${BASE_PATH}score-rank`,
	FRIEND_PAGE: `${BASE_PATH}friend`,
	MORE_PAGE: `${BASE_PATH}more`,
	ROOM_PAGE: `${BASE_PATH}room/:roomId`,
	PLAYROOM_PAGE: `${BASE_PATH}room-play/:roomId/:gameId`,
	LOGIN_PASS_MOBILE: `${BASE_PATH}login`,
	LOGIN_OTP_MOBILE: `${BASE_PATH}login-otp`,
	OTP_MOBILE: `${BASE_PATH}confirm-otp`,
	PROFILE_PAGE: `${BASE_PATH}profile`,
	MY_ACCOUNT: `${BASE_PATH}profile/my-account`,
	SELECT_AVA: `${BASE_PATH}profile/select-ava`,
	GIFT_HIST: `${BASE_PATH}profile/gift-hist`,
	INVITATION: `${BASE_PATH}profile/invitation`,
	INTRODUCE: `${BASE_PATH}profile/introduce`,
	SETTING: `${BASE_PATH}profile/setting`,
	CHANGE_PASS: `${BASE_PATH}profile/change-pass`,
	CHANGE_INFO: `${BASE_PATH}profile/change-info`,
	EVENT_WATER_PAGE: `${BASE_PATH}event-water`,
	RESULT_EVENT_WATER_PAGE: `${BASE_PATH}result-event-water`,
	EVENT_BOAT_RACING_PAGE: `${BASE_PATH}boat-racing-festival`,
	RESULT_EVENT_BOAT_RACING_PAGE: `${BASE_PATH}result-boat-racing-festival`,
	UNDEFINED_PAGE: `${BASE_PATH}*`,
	MAINTAIN_PAGE: `${BASE_PATH}maintain`,
	SETTING_PAGE: `${BASE_PATH}:type`,

	BUNPIMAY_PAGE_HOME: `${BASE_PATH}bunpimay`,

	EVENT_BOAT_RACING_PAGE_T10: `${BASE_PATH}event-boat-racing`,
}
